<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 11:07:40
 * @LastEditTime: 2020-06-16 14:25:57
 * @Description: 品牌 logo
 -->
<template>
  <div class="brand" @click="routeToHome">
    <img src="../../../../assets/image/sony-logo.jpg" alt="SONY">
    <img src="../../../../assets/image/pss-logo.jpg" alt="PSS">
  </div>
</template>

<script>
export default {
  name: 'Brand',
  methods: {
    routeToHome() {
      window.open('/mvc/page?loc=portal/gate&skipRefer=1', '_self');
    },
  },
};
</script>

<style lang="less" scoped>
.brand {
  cursor: pointer;
}
</style>
